// =============================================================================
// TIMELINE SECTION COMPONENT
// =============================================================================

import React from 'react';
import { Calendar } from 'lucide-react';
import type { ContentComponent } from '@/types';

interface TimelineSectionProps {
  component: ContentComponent;
}

/**
 * Timeline Section Component
 */
export const TimelineSection: React.FC<TimelineSectionProps> = ({ component }) => {
  return <TimelineSectionImpl component={component} />;
};

/**
 * Timeline Section Implementation
 */
const TimelineSectionImpl: React.FC<{ component: ContentComponent }> = ({ component }) => {
  const { id, title, content, metadata } = component;
  
  const timeline = metadata?.timeline || [];
  
  return (
    <section id={id} className="content-section timeline-section">
      <div className="container">
        {title && (
          <div className="section-header">
            <h2>{title}</h2>
            {content && <p>{content}</p>}
          </div>
        )}
        
        <div className="timeline-container">
          {timeline.map((item: any, index: number) => (
            <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
              <div className="timeline-marker">
                <div className="marker-dot"></div>
              </div>
              
              <div className="timeline-content">
                <div className="timeline-date">
                  <Calendar size={16} />
                  <span>{item.date}</span>
                </div>
                
                <div className="timeline-card">
                  <div className="timeline-header">
                    {item.image && (
                      <div className="timeline-image">
                        <img src={item.image} alt={item.title} loading="lazy" />
                      </div>
                    )}
                    
                    <div className="timeline-title-section">
                      <h3>{item.title}</h3>
                      {item.icon && (
                        <div className="timeline-icon">
                          <i className={`icon-${item.icon}`}></i>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="timeline-description">
                    <p>{item.content}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { TimelineSectionImpl };

